// extracted by mini-css-extract-plugin
export default {"loading":"finance_glyphs_loading","spinner":"finance_glyphs_spinner"};